import { render, staticRenderFns } from "./LotteryRule.vue?vue&type=template&id=41061b5e"
import script from "./LotteryRule.vue?vue&type=script&lang=js"
export * from "./LotteryRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports